import { render, staticRenderFns } from "./Cadrage copy.vue?vue&type=template&id=5f806ade"
import script from "./Cadrage copy.vue?vue&type=script&lang=js"
export * from "./Cadrage copy.vue?vue&type=script&lang=js"
import style0 from "./Cadrage copy.vue?vue&type=style&index=0&id=5f806ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports